/* CardX Redesign – Theme-Logik (ohne externe Bibliotheken) */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const CX = (window.CX = window.CX || {});
  const routes = Object.assign({ cart: '/cart', cartAdd: '/cart/add' }, CX.routes || {});
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const esc = (str) =>
    String(str == null ? '' : str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function formatMoney(cents) {
    const format = CX.moneyFormat || '{{amount_with_comma_separator}} €';
    const value = (Number(cents) || 0) / 100;
    const group = (n, sep, dec, decimals) => {
      const parts = n.toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (parts[1] ? dec + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount':
          return group(value, ',', '.', 2);
        case 'amount_no_decimals':
          return group(value, ',', '.', 0);
        case 'amount_no_decimals_with_comma_separator':
          return group(value, '.', ',', 0);
        case 'amount_with_apostrophe_separator':
          return group(value, "'", '.', 2);
        default:
          return group(value, '.', ',', 2);
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(html, type) {
    let el = $('#cx-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cx-toast';
      el.className = 'cx-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    el.dataset.type = type || 'ok';
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 5000);
  }

  /* ---------- Warenkorb-Zähler ---------- */
  async function refreshCartCount(count) {
    if (typeof count !== 'number') {
      try {
        const res = await fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } });
        count = (await res.json()).item_count;
      } catch (e) {
        return;
      }
    }
    $$('[data-cx-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- AJAX: In den Warenkorb ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-cx-ajax]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    /* Menge auf den erlaubten Bereich begrenzen (max = Lagerbestand), bevor gesendet wird */
    const qtyField = form.querySelector('[data-cx-qty-input]');
    if (qtyField) {
      const qMax = qtyField.max !== '' ? Number(qtyField.max) : Infinity;
      const qMin = qtyField.min !== '' ? Number(qtyField.min) : 1;
      const qVal = Math.min(qMax, Math.max(qMin, Math.floor(Number(qtyField.value) || qMin)));
      if (String(qVal) !== qtyField.value) qtyField.value = qVal;
    }
    const body = new FormData(form);
    if (CX.cartDrawer) {
      body.append('sections', 'cx-cart-drawer');
      body.append('sections_url', window.location.pathname);
    }
    try {
      const res = await fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Der Artikel konnte nicht hinzugefügt werden.');
      }
      await refreshCartCount();
      document.dispatchEvent(new CustomEvent('cx:cart:changed', { detail: { added: data } }));
      if (CX.cartDrawer) {
        document.dispatchEvent(new CustomEvent('cx:cart:added', { detail: data }));
      } else {
        toast(
          '<span class="cx-toast__icon" aria-hidden="true">✓</span>' +
            '<span class="cx-toast__text"><strong>' + esc(data.product_title || data.title) + '</strong> liegt im Warenkorb.</span>' +
            '<a class="cx-toast__link" href="' + routes.cart + '">Zum Warenkorb</a>'
        );
      }
    } catch (error) {
      toast('<span class="cx-toast__text">' + esc(error.message) + '</span>', 'error');
      /* Shopify legt bei zu hoher Menge oft trotzdem die verfügbare Menge in den Warenkorb – Anzeige abgleichen */
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('cx:cart:refresh'));
      document.dispatchEvent(new CustomEvent('cx:cart:changed', { detail: {} }));
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = button.dataset.soldout === 'true';
      }
    }
  });

  /* ---------- Panels (Menü, Suche, Filter, Warenkorb) ---------- */
  function panel(el, openers, options) {
    if (!el) return null;
    const opts = Object.assign({ lock: true, useHidden: true, focus: 'a, button, input, select', onOpen: null }, options || {});
    let lastFocus = null;
    const isOpen = () => el.classList.contains('is-open');
    const setExpanded = (state) => openers.forEach((b) => b.setAttribute('aria-expanded', String(state)));
    const open = () => {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      if (opts.useHidden) el.hidden = false;
      void el.offsetWidth; /* Reflow erzwingen, damit die Einblendung animiert */
      el.classList.add('is-open');
      if (opts.lock) document.documentElement.classList.add('cx-lock');
      setExpanded(true);
      if (opts.onOpen) opts.onOpen();
      const target = el.querySelector(opts.focus);
      if (target) setTimeout(() => target.focus({ preventScroll: true }), 60);
    };
    const close = () => {
      if (!isOpen()) return;
      el.classList.remove('is-open');
      if (opts.lock) document.documentElement.classList.remove('cx-lock');
      setExpanded(false);
      setTimeout(() => {
        if (!isOpen() && opts.useHidden) el.hidden = true;
      }, reduceMotion ? 0 : 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    openers.forEach((b) => b.addEventListener('click', () => (isOpen() ? close() : open())));
    el.addEventListener('click', (e) => {
      if (e.target === el || e.target.closest('[data-cx-close]')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        const focusables = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', el).filter(
          (n) => n.offsetParent !== null
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
    return { open, close, isOpen };
  }

  function initHeader() {
    panel($('#cx-drawer'), $$('[data-cx-drawer-open]'));
    CX.searchPanel = panel($('#cx-search'), $$('[data-cx-search-open]'), { lock: false, focus: 'input[type="search"]' });
    document.addEventListener('click', (e) => {
      const sp = CX.searchPanel;
      if (sp && sp.isOpen() && !e.target.closest('#cx-search, [data-cx-search-open]')) sp.close();
    });
    const header = $('[data-cx-header]');
    if (header) {
      const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    const announce = $('[data-cx-announce]');
    if (announce) {
      /* Ausgeblendete Hinweise (z. B. Bonusprogramm im Vorschau-Modus) nicht mitrotieren */
      const items = $$('[data-cx-announce-item]', announce).filter((el) => getComputedStyle(el).display !== 'none');
      if (items.length > 1 && !reduceMotion) {
        let i = 0;
        items[0].classList.add('is-active');
        setInterval(() => {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, 4200);
      } else if (items[0]) {
        items[0].classList.add('is-active');
      }
    }
  }

  /* ---------- Horizontale Galerien ---------- */
  function initRails(root) {
    $$('[data-cx-rail]', root || document).forEach((rail) => {
      if (rail.dataset.cxReady) return;
      rail.dataset.cxReady = '1';
      const track = $('[data-cx-rail-track]', rail);
      const prev = $('[data-cx-rail-prev]', rail);
      const next = $('[data-cx-rail-next]', rail);
      if (!track) return;
      const step = () => {
        const cs = getComputedStyle(track);
        /* Desktop (ohne Innenabstand): genau eine Seite weiter, sonst wie bisher */
        if (parseFloat(cs.paddingLeft) === 0) return track.clientWidth + (parseFloat(cs.columnGap) || 0);
        return Math.max(track.clientWidth * 0.82, 260);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        rail.classList.toggle('is-scrollable', max > 2);
      };
      const behavior = reduceMotion ? 'auto' : 'smooth';
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior }));
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Einblend-Animation ---------- */
  function initReveal() {
    const items = $$('[data-reveal]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    document.documentElement.classList.add('cx-reveal-ready');
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        }),
      { rootMargin: '0px 0px -4% 0px' }
    );
    items.forEach((el) => io.observe(el));
  }

  /* ---------- Helle Produktfotos erkennen ----------
     Fotos mit weißem Hintergrund erhalten eine helle Bildfläche statt eines weißen Kastens. */
  const TONE_SEL = '.cx-card__media, .cx-gallery__slide, .cx-cat__media, .cx-line__media, .cx-dline__media, .cx-ps__media';
  let toneCache = {};
  try {
    toneCache = JSON.parse(localStorage.getItem('cx-tone2') || '{}');
  } catch (e) {
    toneCache = {};
  }
  const toneKey = (src) => String(src || '').split('?')[0].replace(/^https?:/, '');
  const saveTone = () => {
    try {
      const keys = Object.keys(toneCache);
      if (keys.length > 400) keys.slice(0, keys.length - 400).forEach((k) => delete toneCache[k]);
      localStorage.setItem('cx-tone2', JSON.stringify(toneCache));
    } catch (e) {
      /* Speicher nicht verfügbar – Erkennung läuft dann bei jedem Aufruf */
    }
  };
  function measureTone(img) {
    try {
      const s = 24;
      const canvas = document.createElement('canvas');
      canvas.width = s;
      canvas.height = s;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, s, s);
      const d = ctx.getImageData(0, 0, s, s).data;
      let n = 0;
      let white = 0;
      for (let y = 0; y < s; y += 1) {
        for (let x = 0; x < s; x += 1) {
          if (x > 1 && x < s - 2 && y > 1 && y < s - 2) continue;
          const i = (y * s + x) * 4;
          if (d[i + 3] < 200) continue;
          const l = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
          n += 1;
          if (l >= 228) white += 1;
        }
      }
      if (!n) return null;
      /* Mindestens 75 % des Bildrands nahezu weiß = Foto mit weißem Hintergrund */
      return white / n >= 0.75;
    } catch (e) {
      return null;
    }
  }
  function initMediaTone(root) {
    $$(TONE_SEL, root || document).forEach((box) => {
      if (box.dataset.cxTone) return;
      const img = box.querySelector('img');
      if (!img) return;
      box.dataset.cxTone = '1';
      const key = toneKey(img.getAttribute('src'));
      if (key in toneCache) {
        box.classList.toggle('is-light', toneCache[key]);
        return;
      }
      const run = () => {
        const light = measureTone(img);
        if (light === null) return;
        toneCache[key] = light;
        box.classList.toggle('is-light', light);
        saveTone();
      };
      if (img.complete && img.naturalWidth) run();
      else img.addEventListener('load', run, { once: true });
    });
  }

  /* ---------- Mengenauswahl ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-cx-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-cx-qty]');
    const input = wrap && $('[data-cx-qty-input]', wrap);
    if (!input) return;
    const step = Number(btn.dataset.cxQtyStep) || 0;
    const min = input.min !== '' ? Number(input.min) : 0;
    const max = input.max !== '' ? Number(input.max) : Infinity;
    const value = Math.min(max, Math.max(min, (Number(input.value) || 0) + step));
    if (String(value) !== input.value) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Formulare, die beim Ändern sofort senden (z. B. Lieferland) ---------- */
  document.addEventListener('change', (event) => {
    const el = event.target.closest('[data-cx-autosubmit]');
    if (el && el.form) el.form.submit();
  });

  /* ---------- Warenkorbseite ---------- */
  function initCart() {
    const form = $('[data-cx-cart-form]');
    if (!form) return;
    let timer;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-cx-qty-input]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        form.classList.add('is-updating');
        form.submit();
      }, 450);
    });
  }

  window.CXTheme = { formatMoney, refreshCartCount, toast, panel, initMediaTone, initRails, $, $$, esc, reduceMotion };

  function init() {
    initHeader();
    initRails();
    initReveal();
    initMediaTone();
    initCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    initRails(e.target);
    initMediaTone(e.target);
  });
})();
